/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';

import { SearchRecourseClaimsRestResponse } from '../../models/search-recourse-claims-rest-response';
import { RequestBuilder } from '../../request-builder';
import { StrictHttpResponse } from '../../strict-http-response';

export interface SearchRecourseClaimsByParam$Params {
  sparePartNumber?: string;
  recourseState?: string;
  objectCriteria?: string;
}

export function searchRecourseClaimsByParam(
  http: HttpClient,
  rootUrl: string,
  params?: SearchRecourseClaimsByParam$Params,
  context?: HttpContext,
): Observable<StrictHttpResponse<SearchRecourseClaimsRestResponse>> {
  const rb = new RequestBuilder(rootUrl, searchRecourseClaimsByParam.PATH, 'get');
  if (params) {
    rb.query('sparePartNumber', params.sparePartNumber, {});
    rb.query('recourseState', params.recourseState, {});
    rb.query('objectCriteria', params.objectCriteria, {});
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<SearchRecourseClaimsRestResponse>;
    }),
  );
}

searchRecourseClaimsByParam.PATH = '/recourse-claim/searchByParam';
